import { Configuration, LogLevel } from '@azure/msal-browser';
import { getConfig } from '@/modules/common/helpers/config';
import { logger } from '@common/logging/logger';

const { auth } = getConfig();

export const msalConfig: Configuration = {
  auth: {
    clientId: auth.clientId,
    authority: auth.authority,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Info,
      piiLoggingEnabled: false,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;

        // logging for MSAL.
        // if (level === LogLevel.Error) {
        //   logger.error('[MSAL]', message);
        // } else if (level === LogLevel.Warning) {
        //   logger.warn('[MSAL]', message);
        // } else if (level === LogLevel.Info) {
        //   logger.info('[MSAL]', message);
        // }
      },
    },
  },
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: ['openid'],
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: 'Enter_the_Graph_Endpoint_Here/v1.0/me',
};

export async function callMsGraph(accessToken) {
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append('Authorization', bearer);

  const options = {
    method: 'GET',
    headers,
  };

  return fetch(graphConfig.graphMeEndpoint, options)
    .then((response) => response.json())
    .catch((error) => logger.error('error fetching graph data', error));
}
